import { render, staticRenderFns } from "./SwitchActiveOrg.vue?vue&type=template&id=db118876&"
import script from "./SwitchActiveOrg.vue?vue&type=script&lang=js&"
export * from "./SwitchActiveOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports